"use strict";function resume$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.resume$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="media.voiceRecorder.resume";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.12"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.12"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"5.1.12"},_a)),exports.resume$=resume$,exports.default=resume$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/media/voiceRecorder/resume.js
// module id = 1082
// module chunks = 106